import { PostNetworkQuery } from "@coris-ts/repository/query/network.query"
import { type HttpBody } from "@coris-ts/data/parameter-type"
import { ApiEndpoint } from "../../../shared/api-endpoint"

export class MetaAdsQuery extends PostNetworkQuery {
  constructor(private readonly bodyData: Record<string, unknown>) {
    super(ApiEndpoint.MetaAds)
  }

  public get body(): HttpBody {
    return this.bodyData
  }
}
